import { DeferrablePromise, DEFERRABLE_PROMISE_TIMEOUT_ERROR } from '../utils/DeferrablePromise';
import ExtensionEventResult from './schema/ExtensionEventResult';
import { InvokeAppAddinCommandStatusCode } from 'owa-addins-store';

const UILESS_TIMEOUT_IN_MS = 330000;
const pendingUILessAddins: { [key: string]: DeferrablePromise<ExtensionEventResult> } = {};

export function setPendingUILess(controlId: string): Promise<ExtensionEventResult> {
    const pendingUILess = new DeferrablePromise<ExtensionEventResult>(UILESS_TIMEOUT_IN_MS);
    pendingUILessAddins[controlId] = pendingUILess;

    return pendingUILess.catch<ExtensionEventResult>((error: Error) => {
        if (error.message === DEFERRABLE_PROMISE_TIMEOUT_ERROR) {
            return {
                status: InvokeAppAddinCommandStatusCode.TimedOut,
            };
        }
        return {
            status: InvokeAppAddinCommandStatusCode.Unknown,
        };
    });
}

export function resolvePendingUILess(controlId: string, result: ExtensionEventResult): void {
    if (pendingUILessAddins[controlId]) {
        const promise = pendingUILessAddins[controlId];
        promise.resolve(result);
        delete pendingUILessAddins[controlId];
    }
}
